var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',_vm._g(_vm._b({attrs:{"app":_vm.app,"dense":_vm.dense,"hide-on-scroll":_vm.hideOnScroll,"role":_vm.role}},'v-app-bar',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }